<template>
  <v-navigation-drawer
    :value="drawer"
    @input="setDrawer($event)"
    :dark="dark"
    :width="260"
    right
    app
    class="d-print-none hidden-md-and-up"
    fixed
    temporary
    overlay-color="#00559E"
    touchless
  >
    <v-container
      fluid
      class="d-flex justify-space-between align-center primary py-2"
    >
      <img height="10" :src="desktopLogo" alt="AV - AGIL" />
      <v-icon color="white" dark @click="toggleDrawer">mdi-close</v-icon>
    </v-container>
    <v-list class="margin-list">
      <template v-for="item in items">
        <!--group with subitems-->
        <v-list-group
          v-if="item.items"
          v-show="hasPermission(item.permission)"
          :key="item.title"
          :group="item.group"
          no-action
        >
          <template #activator>
            <v-list-item-title class="item-list primary--text text-body-1">
              <v-icon color="primary">{{ item.icon }}</v-icon>
              <span class="ml-2">{{ $t(item.title) }}</span>
            </v-list-item-title>
          </template>
          <template #appendIcon>
            <v-icon color="primary">mdi-chevron-down</v-icon>
          </template>

          <template v-for="subItem in item.items">
            <!--sub group-->
            <v-list-group
              v-if="subItem.items"
              v-show="hasPermission(subItem.permission)"
              :key="subItem.name"
              :group="subItem.group"
              sub-group
              class="item-list"
            >
              <template #activator>
                <v-list-item-title class="primary--text text-body-1">
                  {{ $t(subItem.title) }} *
                </v-list-item-title>
              </template>
            </v-list-group>
            <!--child item-->
            <v-list-item
              v-else-if="hasPermission(subItem.permission)"
              :key="`child-${subItem.name}`"
              :to="genChildTarget(item, subItem)"
              :href="subItem.href"
              :disabled="subItem.disabled"
              :target="subItem.target"
              ripple
              class="pl-5"
            >
              <v-list-item-content>
                <v-list-item-title class="primary--text text-body-2">
                  <span>{{ $t(subItem.title) }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
        <!--top-level link-->
        <v-list-item
          v-else
          :key="`item-${item.name}`"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          ripple
          exact
        >
          <v-list-item-action v-if="item.icon" class="d-flex flex-row">
            <v-icon color="primary">{{ item.icon }}</v-icon>
            <v-list-item-title class="init ml-2 primary--text text-body-1">
              {{ $t(item.title) }}
            </v-list-item-title>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
    <language-menu-drawer v-if="user" />
    <v-list class="margin-list">
      <v-list-group no-action v-if="user">
        <template #activator>
          <v-list-item-title class="primary--text text-body-1">
            <v-icon color="primary">mdi-account</v-icon>
            <span class="ml-2">{{ username }}</span>
          </v-list-item-title>
        </template>
        <template #appendIcon>
          <v-icon color="primary">mdi-chevron-down</v-icon>
        </template>
        <v-list-item @click="handleReset" ripple class="pl-5">
          <v-list-item-content>
            <v-list-item-title>
              <span class="primary--text text-body-2">
                {{
                  twofactor
                    ? $t('twofactor_reset_label')
                    : $t('twofactor_menu_install')
                }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <!-- LOGOUT -->
      <v-list-item
        class="item-list"
        :active-class="dark ? 'list-color' : 'black--text'"
        ripple
        @click="objs[1].click"
      >
        <v-list-item-action class="d-flex flex-row">
          <v-icon color="primary">mdi-logout-variant</v-icon>
          <v-list-item-title class="ml-2 primary--text text-body-1">
            {{ $t('menu_logout') }}
          </v-list-item-title>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Menu from '@/api/menu'
import LanguageMenuDrawer from '@/components/commons/LanguageMenuDrawer'
import { hasPermission } from '@/utils'

export default {
  components: { LanguageMenuDrawer },
  name: 'AppDrawer',
  data() {
    return {
      activate: 'primary--text activate-list-item',
      item: 1,
      logo: require('@/assets/AV_003_logo_header.svg'),
      dark: false,
      objs: [
        {
          icon: 'mdi-account-box',
          href: '/perfil',
          title: 'Perfíl',
          click: () => {}
        },
        {
          icon: 'mdi-logout',
          title: 'Salir',
          click: () => this.handleLogout()
        }
      ]
    }
  },
  computed: {
    ...mapState(['drawer']),
    ...mapState('auth', ['user']),
    ...mapState('setting', ['whiteBranding']),
    ...mapState('account', ['account']),

    username() {
      return this.user?.first_name.substring(0, 30)
    },
    desktopLogo() {
      return this.user?.broker && this.whiteBranding
        ? `data:image/png;base64,${this.user.broker.img_desktop}`
        : require('@/assets/logo-mobile.svg')
    },
    twofactor() {
      return this.user?.twofactor_habilitated
    },
    items() {
      const elements = [...Menu]
      return this.account ? elements : elements.filter(item => item.public)
    }
  },
  methods: {
    ...mapActions(['setDrawer']),
    ...mapActions('auth', ['logout']),
    ...mapActions(['toggleDrawer']),
    genChildTarget(item, subItem) {
      if (subItem.href) return
      if (subItem.component) {
        return {
          name: subItem.component
        }
      }
      return { name: `${item.group}/${subItem.name}` }
    },
    hasPermission(permission) {
      return hasPermission(this.user, permission)
    },
    async handleLogout() {
      try {
        await this.logout()
      } catch (error) {
        console.log(error)
      } finally {
        if (process.env.VUE_APP_REDIRECT_URL) {
          window.open(process.env.VUE_APP_REDIRECT_URL, '_self')
        } else {
          this.$router.push({ name: 'Login' })
        }
      }
    },
    async handleReset() {
      this.$router.push({ name: 'Delete' })
    }
  }
}
</script>
<style lang="sass" scoped>
.margin-list
  padding: 0

.init
  margin-left: 2px

.v-list-item--active
  .text-body-1, .text-body-2
    font-weight: bold !important
</style>
